"use client";

export default function GlobalError() {
  return (
    <html lang="zh-Hant">
      <body>
        <p>系統錯誤，請重試或回到首頁</p>
      </body>
    </html>
  );
}
